import { render, staticRenderFns } from "./CreateEditProduct.vue?vue&type=template&id=25a2e62e&scoped=true&"
import script from "./CreateEditProduct.vue?vue&type=script&lang=js&"
export * from "./CreateEditProduct.vue?vue&type=script&lang=js&"
import style0 from "./CreateEditProduct.vue?vue&type=style&index=0&id=25a2e62e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a2e62e",
  null
  
)

export default component.exports